import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import AxisEditForm from '../../elements/axis/form';
import Loading from './../../elements/loading';
import AxisAdd from './../../elements/axis/widget/axis_add';

class AxisEdit extends Component {
	render() {
		const { axis} = this.props;
		return (
			axis.isFetching ? <Loading/>:<AxisEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.axisEdit(this.props.match.params.id);
	}
}

export default BaseLayout(AxisEdit, {
	title:"Editar eje",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <AxisAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/axis/edit.jsx